export default __webpack_public_path__ + "static/media/raya-bg-mobile.2d0a2c19.png";